import {GenericMutationResponse, GraphQLResponse} from "@/lib/types/common.ts";
import {CredentialType, Credentials} from "@/lib/types/credentials.ts";

export interface ServiceVariable {
  id?: number;
  account: string;
  service: string;
  credential: Credentials;
  variable_name: string;
  property_name: string;
}

export interface ServiceVariableInput {
  service_id: number;
  credential_id: number;
  variable_name: string;
  property_name: string;
}

export interface ServiceVariableNoServiceInput extends Omit<ServiceVariableInput, "service_id"> {}

export interface GeneratedServiceVariableInput extends Omit<ServiceVariableInput, "service_id"> {}

export const CredentialProperties: Record<CredentialType, string[]> = {
  [CredentialType.BASIC]: ["username", "password"],
  [CredentialType.CERTIFICATE]: ["certificate", "key", "passphrase"],
  [CredentialType.TOKEN]: ["secret"],
  [CredentialType.TOTP]: ["secret", "period", "num_digits"],
};

export interface ServiceVariableGroupByCredential {
  credential: Credentials;
  service_variables: ServiceVariable[];
}

export interface ServiceVariableGroupByCredentialResponse {
  response: {data: ServiceVariableGroupByCredential[]};
}

export type ServiceVariableMutationResponse = GraphQLResponse<ServiceVariable>;

export type ServiceVariableDeleteResponse = GenericMutationResponse;
